import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=3af3f3cb&scoped=true&"
import script from "./pageFooter.vue?vue&type=script&lang=js&"
export * from "./pageFooter.vue?vue&type=script&lang=js&"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=3af3f3cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af3f3cb",
  null
  
)

export default component.exports